
window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Toast = {
    init: function () {
        if (!document.getElementById('toast-container')) {
            const container = document.createElement('div');
            container.id = 'toast-container';
            document.body.appendChild(container);
        }
    },

    show: function (type, title, message) {
        this.init();
        const container = document.getElementById('toast-container');

        let icon = '';
        if (type === 'success') icon = 'fa-check-circle';
        else if (type === 'error') icon = 'fa-exclamation-circle';
        else if (type === 'warning') icon = 'fa-exclamation-triangle';
        else icon = 'fa-info-circle';

        const toast = document.createElement('div');
        toast.className = `toast toast-${type}`;
        toast.innerHTML = `
            <i class="fas ${icon} fa-lg"></i>
            <div class="toast-content">
                <div class="toast-title">${title}</div>
                <div class="toast-message">${message}</div>
            </div>
            <button class="toast-close">&times;</button>
        `;

        // Close logic
        const close = () => {
            toast.classList.add('hiding');
            setTimeout(() => toast.remove(), 300);
        };

        toast.querySelector('.toast-close').onclick = close;

        // Auto remove after 5 seconds
        setTimeout(close, 5000);

        container.appendChild(toast);
    }
};
